export function canDownload(link) {
    const regex = /https:\/\/media.[a-zA-Z0-9_]+.win\/post\/[a-zA-Z0-9]+.(jpg|jpeg|png)$/gm;
    return regex.test(link) || link.startsWith("https://media.scored.co/");
}

export function getDownload(link) {
    return link.split("/post/")[1];
}